












































































import {Component, Watch} from 'vue-property-decorator'
import {MetaInfo} from 'vue-meta'
import AppFooter from '@/components/footer/AppFooter.vue'
import Navbar from '@/components/navbar/Navbar.vue'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import {$} from '@/facade'
import {BridgeNetworks} from '@/model/bridge/types/BridgeNetworks'
import BridgeSourceSection from '@/components/BridgeSourceSection.vue'
import BridgeTargetSection from '@/components/BridgeTargetSection.vue'
import {BalanceResponse, ShrikeHelper} from '@/helpers/ShrikeHelper'
import {NeoHelper} from '@/helpers/NeoHelper'
import {EnvHelper} from '@/helpers/EnvHelper'
import {BridgeNetworkHelper} from '@/helpers/BridgeNetworkHelper'
import {BridgeFeeHelper} from '@/helpers/BridgeFeeHelper'
import {BridgeTokenIconHelper} from '@/helpers/BridgeTokenIconHelper'
import {NetworkModeHelper} from '@/helpers/NetworkModeHelper'
import BridgeProceedButton from '@/components/BridgeProceedButton.vue'
import BridgeModal from '@/components/BridgeModal.vue'
import BridgeTokenSelection, {
  BridgeTokenOption,
} from '@/components/BridgeTokenSelection.vue'
import BridgeDisclaimerMobile from '@/components/BridgeDisclaimerMobile.vue'
import BridgeStatsSection from '@/components/BridgeStatsSection.vue'
import BridgeTransferSection from '@/components/BridgeTransferSection.vue'
import BridgedGasBarSection from '@/components/BridgedGasBarSection.vue'

@Component({
  components: {
    BridgedGasBarSection,
    BridgeTransferSection,
    BridgeStatsSection,
    BridgeTokenSelection,
    BridgeModal,
    BridgeProceedButton,
    BridgeTargetSection,
    BridgeSourceSection,
    BridgeDisclaimerMobile,
    Navbar,
    AppFooter,
  },
  computed: {
    $() {
      return $
    },
  },
})
export default class BridgeView extends MixinScreenSize {
  sourceNetwork: BridgeNetworks = 'N3'
  targetNetwork: BridgeNetworks = 'X'

  bridgeFeeAmount = '0.01'

  n3Amount = ''
  xAmount = ''

  isSwapping = false

  n3AccountBalance: BalanceResponse[] = []
  xAccountBalance: BalanceResponse[] = []
  isN3BalanceUnavailable = false
  isXBalanceUnavailable = false
  tokenOptions: BridgeTokenOption[] = []

  selectedToken: BridgeTokenOption | null = null

  sourceAmount: string = ''
  targetAmount: string = ''

  poolingInterval: any = null

  get isSourceBalanceUnavailable() {
    return this.sourceNetwork === 'N3'
      ? this.isN3BalanceUnavailable
      : this.isXBalanceUnavailable
  }

  get balanceUnavailableMessage() {
    return this.isSourceBalanceUnavailable
      ? $.translate(
          NetworkModeHelper.isTestnet()
            ? 'view.BridgeView.balanceUnavailableTestnet'
            : 'view.BridgeView.balanceUnavailable'
        )
      : ''
  }

  get hasNoTokenBalance() {
    if (this.isSourceBalanceUnavailable) {
      return false
    }

    const networkProps = this.getNetworkProps(this.sourceNetwork)
    const tokenBalance = networkProps.accountBalance.find(
      b => b.token.hash === networkProps.hash
    )
    return !tokenBalance
  }

  get hasInsufficientGasForFee() {
    if (this.selectedToken?.symbol !== 'GAS') return false

    const networkProps = this.getNetworkProps(this.sourceNetwork)
    const tokenBalance = networkProps.accountBalance.find(
      b => b.token.hash === networkProps.hash
    )

    return (
      tokenBalance && Number(tokenBalance.amount) < Number(this.bridgeFeeAmount)
    )
  }

  get isMaxAmountSelected() {
    return this.sourceAmount === this.maxAmount
  }

  get minimumReceivedRequired() {
    return this.selectedToken?.minAmount ?? '0'
  }

  get minimumAmountRequired() {
    const token = this.selectedToken

    if (!token) {
      return '0'
    }

    if (token.symbol !== 'GAS') {
      return token.minAmount
    }

    const total = (
      Number(token.minAmount) + Number(this.bridgeFeeAmount)
    ).toFixed(token.n3.decimals)

    return total.replace(/0+$/, '').replace(/\.$/, '')
  }

  get isMinimumAmountRequired() {
    if (!this.targetAmount) {
      return false
    }

    return Number(this.targetAmount) < Number(this.minimumReceivedRequired)
  }

  get isAmountTooLow() {
    if (
      !this.sourceAmount ||
      isNaN(Number(this.sourceAmount)) ||
      Number(this.sourceAmount) <= 0
    ) {
      return true
    }

    if (
      !this.targetAmount ||
      isNaN(Number(this.targetAmount)) ||
      Number(this.targetAmount) <= 0
    ) {
      return true
    }

    if (this.sourceNetwork === this.targetNetwork) {
      return true
    }

    const isGasTokenSelected = this.selectedToken?.symbol === 'GAS'
    return isGasTokenSelected
      ? Number(this.targetAmount) <= Number(this.bridgeFeeAmount)
      : Number(this.targetAmount) <= 0
  }

  get popoverText() {
    if (this.isWalletDisconnected) {
      return $.translate('view.BridgeView.walletDisconnectedDisclaimer')
    }

    if (this.hasNoTokenBalance) {
      return $.translate('view.BridgeView.hasNoTokenBalanceDisclaimer', {
        tokenSymbol: this.selectedToken?.symbol,
        network: this.sourceNetwork,
      })
    }

    if (this.hasInsufficientGasForFee) {
      return $.translate('view.BridgeView.hasInsufficientGasForFeeDisclaimer', {
        tokenSymbol: this.selectedToken?.symbol,
        bridgeFeeAmount: this.bridgeFeeAmount,
      })
    }

    if (this.isAmountTooLow) {
      return $.translate('view.BridgeView.isAmountTooLowDisclaimer', {
        tokenSymbol: this.selectedToken?.symbol,
      })
    }

    if (this.isMinimumAmountRequired) {
      return $.translate('view.BridgeView.isMinimumAmountRequired', {
        minimumAmountRequired: this.minimumAmountRequired,
        tokenSymbol: this.selectedToken?.symbol,
      })
    }

    return ''
  }

  get isProceedButtonDisabled() {
    return (
      this.isWalletDisconnected ||
      this.isMinimumAmountRequired ||
      this.hasNoTokenBalance ||
      this.hasInsufficientGasForFee ||
      this.isAmountTooLow
    )
  }

  get isWalletDisconnected() {
    return (
      !$.walletAdapter.addressOf('n3', BridgeNetworkHelper.network()) ||
      !$.walletAdapter.addressOf('neoX', BridgeNetworkHelper.network())
    )
  }

  get maxAmount() {
    const {accountBalance, hash} = this.getNetworkProps(this.sourceNetwork)
    const balance = accountBalance.find(b => b.token.hash === hash)
    return balance ? String(balance.amount) : '0'
  }

  get selectedTokenDecimals() {
    return this.getNetworkProps(this.sourceNetwork).decimals
  }

  get receivedAmountFormatted() {
    if (!this.targetAmount) {
      return $.translate('view.BridgeView.notAvailable')
    }

    const amount = parseFloat(this.targetAmount).toString()

    return $.translate('view.BridgeView.receivedAmount', {
      amount,
      tokenSymbol: this.selectedToken?.symbol,
    })
  }

  handleSelectToken(token: BridgeTokenOption) {
    this.resetValues()
    this.populateAccountBalance()
    this.selectedToken = token
    this.refreshBridgeFee()
  }

  /**
   * Each token carries its own withdrawal fee on the bridge contract, and GAS
   * crosses as the native coin, so the quote has to follow the selection — and
   * it has to be the very number the withdrawal will send, or the contract
   * rejects the transaction the user was quoted for.
   */
  private async refreshBridgeFee() {
    const token = this.selectedToken

    if (!token) {
      return
    }

    this.bridgeFeeAmount = await BridgeFeeHelper.withdrawalFeeAmount(
      token.symbol === 'GAS' ? undefined : token.x.hash
    )
  }

  getNetworkProps(network: BridgeNetworks) {
    return {
      accountBalance:
        network === 'N3' ? this.n3AccountBalance : this.xAccountBalance,
      decimals:
        network === 'N3'
          ? this.selectedToken?.n3.decimals
          : this.selectedToken?.x.decimals,
      hash:
        network === 'N3'
          ? this.selectedToken?.n3.hash
          : this.selectedToken?.x.hash,
    }
  }

  metaInfo(): MetaInfo {
    const title = this.$translate('metadata.title.bridge') as string
    const description = this.$translate(
      'view.BridgeView.metaDescription'
    ) as string

    return {
      title,
      meta: [
        {vmid: 'description', name: 'description', content: description},
        {vmid: 'og:title', property: 'og:title', content: title},
        {
          vmid: 'og:description',
          property: 'og:description',
          content: description,
        },
        {vmid: 'twitter:title', name: 'twitter:title', content: title},
        {
          vmid: 'twitter:description',
          name: 'twitter:description',
          content: description,
        },
      ],
    }
  }

  async mounted() {
    await this.populateBridgeNetworkConfig()

    this.populateAccountBalance()

    this.poolingInterval = setInterval(() => {
      this.populateAccountBalance(true)
    }, 15000)
  }

  private async populateBridgeNetworkConfig() {
    try {
      await BridgeNetworkHelper.networkAsync()

      const xGasToken = BridgeNetworkHelper.xGasToken()
      const xNeoToken = BridgeNetworkHelper.xNeoToken()

      const additionalToken = BridgeNetworkHelper.additionalToken()

      this.tokenOptions = [
        {
          symbol: 'GAS',
          icon: BridgeTokenIconHelper.forSymbol('GAS'),
          minAmount: '0.1',
          n3: {
            hash: EnvHelper.VUE_APP_GAS_SCRIPT_HASH,
            decimals: 8,
          },
          x: xGasToken,
        },
        {
          symbol: 'NEO',
          icon: BridgeTokenIconHelper.forSymbol('NEO'),
          minAmount: '1',
          n3: {
            hash: EnvHelper.VUE_APP_NEO_SCRIPT_HASH,
            decimals: 0,
          },
          x: xNeoToken,
        },
        ...(additionalToken
          ? [
              {
                symbol: additionalToken.symbol,
                icon: BridgeTokenIconHelper.forSymbol(additionalToken.symbol),
                minAmount: additionalToken.minAmount,
                n3: additionalToken.n3,
                x: additionalToken.x,
              },
            ]
          : []),
      ]
      this.selectedToken = this.tokenOptions[0]

      await this.refreshBridgeFee()
    } catch (error) {
      console.error(error)
      this.threatError($.translate('view.BridgeView.bridgeNotConfigured'))
    }
  }

  beforeDestroy() {
    if (this.poolingInterval) {
      clearInterval(this.poolingInterval)
      this.poolingInterval = null
    }
  }

  async populateAccountBalance(isPolling = false) {
    const promises: Promise<any>[] = []

    if (!isPolling || !this.isN3BalanceUnavailable) {
      promises.push(this.populateN3AccountBalance())
    }

    if (!isPolling || !this.isXBalanceUnavailable) {
      promises.push(this.populateXAccountBalance())
    }

    if (promises.length === 0) {
      return
    }

    await $.await.run(
      'populateAccountBalance',
      async () => await Promise.all(promises)
    )
  }

  async handleChangeSourceAmount(amount: string) {
    if (!amount || isNaN(Number(amount)) || Number(amount) <= 0) {
      this.sourceAmount = ''
      this.targetAmount = ''
      return
    }

    this.sourceAmount = amount

    this.targetAmount =
      this.selectedToken?.symbol === 'GAS'
        ? String((Number(amount) - Number(this.bridgeFeeAmount)).toFixed(8))
        : amount
  }

  handleMaxClick() {
    this.handleChangeSourceAmount(this.maxAmount)
  }

  swapNetworks() {
    this.resetValues()
    this.isSwapping = true

    const tempSourceNetwork = this.sourceNetwork
    const tempTargetNetwork = this.targetNetwork

    this.sourceNetwork = tempTargetNetwork
    this.targetNetwork = tempSourceNetwork
  }

  resetValues() {
    this.n3Amount = ''
    this.xAmount = ''
    this.sourceAmount = ''
    this.targetAmount = ''
  }

  @Watch('$store.state.walletAdapter.n3.address')
  onN3AddressChange() {
    this.populateN3AccountBalance()
  }

  @Watch('$store.state.walletAdapter.neoX.address')
  onXAddressChange() {
    this.populateXAccountBalance()
  }

  private async populateN3AccountBalance() {
    try {
      const address = $.walletAdapter.addressOf(
        'n3',
        BridgeNetworkHelper.network()
      )

      if (!address) {
        console.error('N3 Address undefined')
        return
      }

      this.n3AccountBalance = await ShrikeHelper.getBalance(
        address,
        BridgeNetworkHelper.n3Network()
      )
      this.isN3BalanceUnavailable = false
    } catch (error) {
      this.onBalanceFailure('N3', error)
    }
  }

  private async populateXAccountBalance() {
    try {
      const address = $.walletAdapter.addressOf(
        'neoX',
        BridgeNetworkHelper.network()
      )

      if (!address) {
        console.error('X Address undefined')
        return
      }

      this.xAccountBalance = await NeoHelper.getNeoXBridgeBalances(address)
      this.isXBalanceUnavailable = false
    } catch (error) {
      this.onBalanceFailure('X', error)
    }
  }

  private onBalanceFailure(network: BridgeNetworks, error: unknown) {
    console.error(`[Bridge] ${network} balance unavailable`, error)

    if (network === 'N3') {
      this.n3AccountBalance = []
      this.isN3BalanceUnavailable = true
      return
    }

    this.xAccountBalance = []
    this.isXBalanceUnavailable = true
  }

  private threatError(message: string) {
    $.toast.abort(message)
  }
}
